// extracted by mini-css-extract-plugin
export var dropdownButton = "_3a-0";
export var fullWidthDropdownButton = "_3a-1";
export var icon = "_3a-3";
export var iconPlaceholder = "_3a-2";
export var shortcutContainer = "_3a-4";